import React from 'react'
import * as C from "../componentsM/index";
import { FaUser, FaGraduationCap, FaFacebookSquare, FaImage } from "react-icons/fa";
import { IoMdMail } from "react-icons/io";
import { IoLogoLinkedin } from "react-icons/io5";
import { GrLink } from "react-icons/gr";



const AlumniRegistration = () => {
    return (
        <>

            <C.Hero title={"ALUMNI REGISTRATION"} image={"/hero/11.jpg"} />

            <section className='p-4 md:p-24'>

                <div className='flex flex-col gap-5 border border-myGray/50 p-[.15rem] rounded-md '>

                    <form className='flex flex-col '>

                        <div className='flex-1 text-center text-white text-xl md:text-3xl font-bold bg-myGray/50 py-6'>
                            Applicant Details
                        </div>


                        <div className='flex flex-wrap items-center justify-between gap-2 p-3'>


                            <div className='w-full md:w-80'>

                                <label htmlFor="name" className='flex items-center gap-2'><IoMdMail /> Name</label>
                                <input id='name' type="text" className='w-full' />

                            </div>


                            <div className='w-full md:w-80'>

                                <label htmlFor="email" className='flex items-center gap-2'><FaUser />  Email:</label>
                                <input id='email' type="email" className='w-full' />

                            </div>

                            <div className='w-full md:w-80'>

                                <label htmlFor="year" className='flex items-center gap-2'><FaGraduationCap />  Year of Passout</label>
                                <select id="year" className='w-full'>

                                    {Array.from({ length: 25 }, (_, i) => 2000 + i).map(v => (
                                        <option key={v} value={v}>
                                            {v}
                                        </option>
                                    ))}


                                </select>

                            </div>


                            <div className='w-full md:w-80'>

                                <label htmlFor="link" className='flex items-center gap-2'><IoLogoLinkedin />  LinkedIn Profile</label>
                                <input id='link' type="text" className='w-full' />

                            </div>

                            <div className='w-full md:w-80'>

                                <label htmlFor="face" className='flex items-center gap-2'><FaFacebookSquare />  Facebood Profile</label>
                                <input id='face' type="text" className='w-full' />

                            </div>

                            <div className='w-full md:w-80'>

                                <label htmlFor="web" className='flex items-center gap-2'><GrLink />  Another link available</label>
                                <input id='web' type="text" className='w-full' />

                            </div>
                            <div className='w-full md:w-80'>

                                <label htmlFor="image" className='flex items-center gap-2'><FaImage />  Select Image:</label>
                                <input id='image' type="file" className='w-full' />

                            </div>


                        </div>

                        <div className='w-full flex items-center justify-end '>
                            <button className='text-white capitalize bg-black/90 px-6 rounded-md py-4 mt-6'> register</button>
                        </div>

                    </form>

                </div>


            </section>

        </>
    )
}

export default AlumniRegistration